import SettingsKey from 'app/profile/settings/utils/settingsTypes';
import { useSettingValue } from 'common/hooks/useSettingValue';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { addActor } from 'redux/slices/actorSlice';
import { getUser } from 'redux/slices/authSlice';
import { closeCustomDialogAction } from 'redux/slices/customDialogSlice';
import { addEventAction } from 'redux/slices/eventSlice';
import EventForm from './eventForm/EventForm';

const EventSessionCreate = (props) => {
    const { startDate, calendarEvent, instant, onSubmit, guest, onCancel } = props;

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(getUser);

    const getEventName = () => {
        if (calendarEvent) {
            return calendarEvent.title || calendarEvent.name;
        }
        return instant ? t('event.eventSessionCreate.psEvent') : '';
    };

    const getReleaseDate = () => {
        if (calendarEvent) {
            return calendarEvent.start;
        }
        return startDate || new Date();
    };

    const event = {
        id: null,
        name: getEventName(),
        description: '',
        releaseDate: getReleaseDate(),
        adminUserId: user.userId,
        duration: calendarEvent
            ? new Date(calendarEvent.end).getMinutes() - new Date(calendarEvent.start).getMinutes()
            : 30,
        inviteeName: calendarEvent ? calendarEvent.inviteeName : null,
        inviteeEmail: calendarEvent ? calendarEvent.inviteeEmail : null,
        calendlyEventUri: calendarEvent ? calendarEvent.eventUri : null,
        type: 'one_to_one',
        isTemplate: true,
        instant: instant,
        calendlyEventTypeUri: calendarEvent ? calendarEvent.eventTypeUri : null,
        ...(calendarEvent && { sessionRequestId: calendarEvent.id }),
        callOrigin: 'cms',
        reminders: useSettingValue(SettingsKey.ICALL_EMAIL_REMINDERS) ?? [],
    };

    useEffect(() => {
        if (calendarEvent) {
            if (calendarEvent.inviteeEmail) {
                dispatch(
                    addActor({
                        email: calendarEvent.inviteeEmail,
                        role: 'guest',
                    }),
                );
            }
            if (calendarEvent.guests) {
                calendarEvent.guests.forEach((email) => {
                    dispatch(
                        addActor({
                            email,
                            role: 'guest',
                        }),
                    );
                });
            }
        }
    }, [calendarEvent, dispatch]);

    useEffect(() => {
        if (guest) {
            dispatch(
                addActor({
                    email: guest.email,
                    role: 'guest',
                }),
            );
        }
    }, [dispatch, guest]);

    const handleSubmit = (editedEvent, callbackOk, callbackError) => {
        if (!calendarEvent) {
            const actor = editedEvent.actors.find((a) => a.role === 'guest');
            if (actor) {
                editedEvent = {
                    ...editedEvent,
                    inviteeEmail: actor.email,
                };
            }
        }
        dispatch(
            addEventAction(
                editedEvent,
                (taskResult) => {
                    callbackOk(taskResult);
                    if (onSubmit) {
                        onSubmit(taskResult);
                    }
                    dispatch(closeCustomDialogAction());
                },
                (taskResult) => callbackError(taskResult),
            ),
        );
    };

    return (
        <EventForm
            action={t('event.eventSessionCreate.newEvent')}
            event={event}
            onSubmit={handleSubmit}
            wizardMode={true}
            onCancel={onCancel}
        />
    );
};

export default EventSessionCreate;
